import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Windows = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="51"
          height="48"
          viewBox="0 0 51 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.7249 35.6239H5.20056C2.34025 35.6239 0 33.2836 0 30.4233V5.20056C0 2.34025 2.34025 0 5.20056 0H44.9849C47.8452 0 50.1854 2.34025 50.1854 5.20056V30.6833C49.9254 33.2836 47.5852 35.6239 44.7249 35.6239Z"
            fill="url(#windows_linear)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.0601 45.4638C18.5628 45.4638 12.0981 46.2986 7.22056 47.9244C6.45846 48.1784 5.63473 47.7666 5.3807 47.0045C5.12667 46.2424 5.53854 45.4186 6.30063 45.1646C11.5642 43.4101 18.3609 42.5547 25.0601 42.5547C31.7573 42.5547 38.4946 43.4096 43.6354 45.1683C44.3954 45.4283 44.8008 46.2552 44.5408 47.0153C44.2807 47.7754 43.4538 48.1807 42.6937 47.9207C37.9534 46.299 31.5593 45.4638 25.0601 45.4638Z"
            fill="#2C5CD4"
          />
          <path
            d="M16 23.4986L22.6727 24.5195V17.8535L16 17.8253V23.4986Z"
            fill="white"
          />
          <path
            d="M23.4541 24.6402V17.8611L32.3199 17.8975V26L23.4541 24.6402Z"
            fill="white"
          />
          <path
            d="M16 17.1016L22.6727 17.0774V10.3992L16 11.3717V17.1016Z"
            fill="white"
          />
          <path
            d="M23.458 17.0742L32.3199 17.0298V8.99991L23.458 10.2912V17.0742Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="windows_linear"
              x1="25.0927"
              y1="0"
              x2="25.0927"
              y2="35.6239"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#9AB6EE" />
              <stop offset="1" stopColor="#1E4FCE" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default Windows;
